import { render } from "./SingleBoxPlan.vue?vue&type=template&id=00a3fd42&scoped=true"
import script from "./SingleBoxPlan.vue?vue&type=script&lang=js"
export * from "./SingleBoxPlan.vue?vue&type=script&lang=js"

import "./SingleBoxPlan.vue?vue&type=style&index=0&id=00a3fd42&scoped=true&lang=css"

import exportComponent from "/home/adrianhardy/projects/Clients/O/Orchard_Crown_Ltd/ionic-storeroom/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00a3fd42"]])

export default __exports__